<template>
  <div>
    <div class="allProject" v-for="(item,index) in tableList" :key="index">
      <div @click="enterDetail(item)">
        <div class="facialName">
          <div class="facialNext">
            <div class="facialList">
              <img class="facialImg" src="../../assets/icon/me.png" alt="">
              <span>{{item.projectName}}</span>
              <span>{{ item.mobile.replace(item.mobile.substr(3, 4), '****') }}</span>
              <img class="myself" src="../../assets/icon/myself.png" alt="">
            </div>
            <div class="nurseName">客服</div>
          </div>
        </div>
        <div class="outpatient">
          <img class="facialImg" src="../../assets/icon/me.png" alt="">
          <span>接待时长:</span>
          <span class="outName">{{item.doctorName}}</span>
        </div>
        <div class="outpatient">
          <img class="facialImg" src="../../assets/icon/me.png" alt="">
          <span>客服:</span>
          <span class="outName">{{item.doctorName}}</span>
        </div>
        <div class="outpatient">
          <img class="facialImg" src="../../assets/icon/me.png" alt="">
          <span>{{item.projectName}}</span>
          <span>{{ item.mobile.replace(item.mobile.substr(3, 4), '****') }}</span>
          <img class="myself" src="../../assets/icon/association.png" alt="">
        </div>
        <div class="outpatient">
          <img class="facialImg" src="../../assets/icon/me.png" alt="">
          <span>接待时长:</span>
          <span class="outName">{{item.doctorName}}</span>
        </div>
        <div class="outpatient">
          <img class="facialImg" src="../../assets/icon/me.png" alt="">
          <span>客服:</span>
          <span class="outName">{{item.doctorName}}</span>
        </div>
      </div>
      <div class="split_line"></div>
      <div class="concat">
        <div class="contactSer">更换客服</div>
        <div class="contactWait">确认接待</div>
        <div class="contactFinish">结束流程</div>
        <div class="contactChange">移交科室</div>
        <div class="contactLine">变更患者</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableList: [
        {
          projectName: "张三",
          mobile: '14525878956',
          doctorName: '苏医生'
        },

      ],
    }
  },
  methods: {
    enterDetail(item) { },
  }
}
</script>
<style scoped>
@import "../../assets/css/customer.css";
</style>


// WEBPACK FOOTER //
// src/components/customerReception/customServise.vue